<template>
  <viewer :article="article">
    <el-breadcrumb slot="header">
      <el-breadcrumb-item :to="{name: 'news'}">News</el-breadcrumb-item>
      <el-breadcrumb-item>{{ article.header }}</el-breadcrumb-item>
    </el-breadcrumb>
  </viewer>
</template>

<script>
import { mapGetters } from 'vuex'

import Viewer from './Viewer'

export default {
  components: {
    Viewer
  },
  computed: {
    ...mapGetters('news', {
      article: 'selected'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/news/Sent.vue